export const siteSettings = {
  name: "Experts Fintech",
  link: "https://expertsfintech.com",
  email: "support@expertsfintech.com",
  appLink: "https://app.expertsfintech.com",
};
